import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import { Row,  Table } from 'reactstrap';

import { useNavigate } from 'react-router-dom';
import { BiEditAlt, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import { BiLeftArrowAlt } from 'react-icons/bi';
import useAuth from '../../hooks/useAuth';
import {ProductPaginationTable} from '../../components/PaginationC/ProductPaginationTable'


const ProductView = () => {
    const { auth } = useAuth();

    const [modal, openModal] = useState(false);
    const toggle = () => openModal(!modal);
    const [products, setProducts] = useState([]);
    const navigate = useNavigate();

    const handleDelete =  async (event, id) => {
        event.preventDefault();
        try {
            const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/products/delete-product/${id}`,  {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            });
            const res1 = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/products/find-all`);
            setProducts(res1.data);
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
        } catch (error) {
            error.response.data.message ? toast.error(error.response.data.message, {
                className: "error-toast",
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
                }) :  toast.error(error.response.data.error, {
                  className: "error-toast",
                  position: toast.POSITION.BOTTOM_RIGHT,
                  autoClose: 3000
              })
         }
    }
        
   
    useEffect(() => {
      const source = axios.CancelToken.source();
      const getproducts = async () => {
      try {
          const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/products/find-all`, {
              cancelToken: source.token
          });
          setProducts(res.data);
         
      } catch (error) {
              if (axios.isCancel(error)) {
                  console.log('cancelled');
              } else {
                  throw error;
              }
          }
      }
      
      getproducts();
      return () => {
          source.cancel();
      };
  },[])
    return (
        <div className="container">
          <Row sm="12">
            <h5 className="sec-header">Product List</h5>
        </Row> 
        <Row>
            <ProductPaginationTable data={products} />
            {/* <Table responsive hover>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>Image</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {
                    products.map(product => (
                      <tr key={product.productId}>
                            <td>{product.productId}</td>
                            <td style={{wordBreak: "break-all"}}>{product.productTitle}</td>
                            <td><img style={{width: 120}} src={process.env.REACT_APP_API_IMAGE_URI.substring(0, process.env.REACT_APP_API_IMAGE_URI.indexOf("/api")) 
                            + `${product.productImg.substring(product.productImg.indexOf("/uploads"))}`} alt={product.productTitle}></img></td>
                            <td>
                                <BiEditAlt className="edit_icon icon_hover" onClick={() => navigate(`/our-experience/edit/${product.productId}`)} size={20}/> 
                                <BiTrash className="delete_icon icon_hover" onClick={(event) => handleDelete(event, product.productId)} size={20} />                              
                            </td>
                    </tr>
                  ))  
                }
                                
                </tbody>
            </Table> */}
     </Row>
     {
        products && <Row sm="12" className="mt-4 text-center">
          <Link to={"/our-experience/add"} className="go_back" >
            <BiLeftArrowAlt size={30} /> Go to Add product
          </Link>
      </Row> 
         }
        </div>
    )
   
}

export default ProductView;